export const POST_HOG_BASE_URL = 'https://grape.tryloop.ai'

// export const POST_HOG = {
//   BASE_URL: 'https://app.posthog.com'
// } as const
